import React from 'react';
import { Box, Button } from '@mui/material';

const DEFAULT_OPTIONS = ['1D', '5D', '1M', '3M', '6M', '1Y', '3Y'];

/**
 * TimeframeSelector — Row of pill buttons for chart timeframe selection.
 */
const TimeframeSelector = ({ active, onChange, options = DEFAULT_OPTIONS }) => {
  return (
    <Box sx={{ display: 'flex', gap: 0.5 }}>
      {options.map((tf) => (
        <Button
          key={tf}
          size="small"
          variant={active === tf ? 'contained' : 'outlined'}
          onClick={() => onChange(tf)}
          sx={{
            minWidth: 36,
            px: 1.2,
            py: 0.4,
            fontSize: 12,
            fontWeight: 600,
            borderRadius: 1.5,
            textTransform: 'none',
            ...(active === tf
              ? {}
              : {
                  borderColor: 'divider',
                  color: 'text.secondary',
                  '&:hover': {
                    borderColor: 'text.secondary',
                    backgroundColor: 'action.hover',
                  },
                }),
          }}
        >
          {tf}
        </Button>
      ))}
    </Box>
  );
};

export default TimeframeSelector;
